module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAcCAMAAABMOI/cAAAAV1BMVEUAAACJmK+KmrGIma+JmbCJmbCJmbCJmbCJmbGImbCOnriJmbCJmbCKmrOJmLCJmbCJmbCKmbGJmbCJm7KKmbGOoLKImbCJmbCKmrCKmbCLmLGImrKImK9BYEf3AAAAHHRSTlMA6VPZ8eLFrI53E4hkMOe1p5qTRzUc26J+cVwrbsmwrgAAAJFJREFUKM+t0tkOgjAQheEpdF9AQVzn/Z9T2wahziTe8F2en4SkLWyCGAIwIn5EJpgcTmS+jFiMqd0tfk37fcKd87Y7bNzX3cs2SE9/UFmo5G+QdU9IvEqYaZhL6Gjojg6Rhic9kOpRwg0rco6Khmu+IYMMk+r3VA9OCYZy8JfuC829Hv79LCLvwwKEt1oHD6s3cx4m9/TjnCMAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/nav_Prompt.png
// module id = 5uDl
// module chunks = 99